<main class="form-signin">
  <form method="post" #loginForm="ngForm" class="text-center">
    <img class="mb-4" src="https://things2.do/wp-content/themes/things2do/images/things2do-logo.png" alt="">
    <h1 class="h4 mb-3 fw-normal">Please sign in</h1>

    <div class="form-floating">
      <input type="email" class="form-control" name="email" id="floatingInput" placeholder="9820012345"
             [(ngModel)]="apiPayLoad.email"
             required="required"
      >
      <label for="floatingInput">Email Address</label>
    </div>

    <div class="form-floating">
      <input type="password" class="form-control" name="password" id="passwordInput"
             [(ngModel)]="apiPayLoad.password"
             minlength="4"
             required="">
      <label for="floatingInput">Password</label>
    </div>

    <div class="mb-3">
      <button class="w-100 btn btn-lg btn-primary" type="button" (click)="doLogin()" [disabled]="!loginForm.valid">
        Continue
      </button>
    </div>

    <div class="alert alert-danger" *ngIf="!isLoggedIn && isResponseReceived">
      Invalid Username/ Password.
    </div>

    <div class="alert alert-success" *ngIf="isResponseReceived && isLoggedIn">
      Login Successful ...
    </div>

    <p class="mt-5 mb-3 text-muted">&copy;2017–2021</p>
  </form>
</main>
